import React, { useMemo, useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useCallback } from "react";
import axios from "axios";
import { API_URL } from "../actions/auth";
import { useSelector, useDispatch } from "react-redux";
import { alertMessage } from "../actions/auth";

const CustomQuill = ({ value, onChange, placeholder, onBlur }) => {
  const quillRef = useRef(null);
  const isMounted = useRef(false);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  // Fix for "addRange" errors and editor initialization
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const imageHandler = useCallback(() => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;

    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;
      const range = editor.getSelection();

      try {
        // Save cursor position
        if (!range) {
          editor.focus();
          return;
        }

        // Insert temporary placeholder
        const placeholderIndex = range.index;
        editor.insertEmbed(placeholderIndex, "image", "LOADING...", "user");

        // Upload image to server
        const formData = new FormData();
        formData.append("image", file);
        console.log(state.auth.token, "......TOKEN");
        const response = await axios.post(`${API_URL}upload_image/`, formData, {
          headers: {
            Authorization: state.auth.token,
            "Content-Type": "multipart/form-data",
          },
        });

        // Replace placeholder with actual image
        editor.deleteText(placeholderIndex, 1, "silent");
        editor.insertEmbed(
          placeholderIndex,
          "image",
          response.data.url,
          "user"
        );
        editor.setSelection(placeholderIndex + 1, 0, "silent");
        onChange(editor.root.innerHTML);
      } catch (error) {
        console.error("Image upload failed:", error);
        // Remove the failed placeholder
        if (range) {
          editor.deleteText(range.index, 1, "silent");
        }
        dispatch(
          alertMessage(
            "ERROR",
            "Image Upload Failed",
            error.response?.data?.message || "Could not upload image"
          )
        );
      }
    };

    input.click();
  }, [state.auth.token, dispatch]);

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image"],
          ["clean"],
        ],
        handlers: {
          image: imageHandler,
        },
      },
      clipboard: {
        matchVisual: false,
      },
    }),
    []
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  return (
    <div className="quill-wrapper">
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        onBlur={onBlur}
        style={{ height: "300px" }}
      />
    </div>
  );
};

export default CustomQuill;
